import { useState } from "react";

export default function PiInteractionNumberInputField(props: {
  label: string;
  value: number;
  onChange: (value: number) => void;
}) {
  const { label, value, onChange } = { ...props };

  const [displayValue, setDisplayValue] = useState(String(props.value));
  return (
    <div className="flex flex-col w-full">
      <div className="text-interaction-primary text-base font-bold h-[30px]">
        {label}
      </div>
      <div className="w-full h-[42px] piXl:h-[68px] piLg:h-[58px] flex bg-interaction-softBackground border-b-2 border-solid border-interaction-primary px-[18px] ">
        <input
          type="text"
          inputMode="decimal"
          value={displayValue}
          onChange={(e) => {
            const val = e.target.value;
            // Allow empty, digits, and single dot
            if (val === "" || /^\d*\.?\d*$/.test(val)) {
              setDisplayValue(val);
              const num = val === "" ? 0 : Number(val);
              if (!isNaN(num) && num >= 0) {
                onChange(num);
              }
            }
          }}
          onBlur={() => {
            // Clean up display on blur
            setDisplayValue(String(props.value || 0));
          }}
          className="w-full text-base font-bold bg-transparent text-interaction-primary focus:outline-none"
        />
      </div>
    </div>
  );
}
